import React from 'react';
import axios from 'axios';
import { Button, Col, Row, Label, FormText, Spinner } from 'reactstrap';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';

const token_id = localStorage.getItem('token');

// รองรับทั้งแม่แบบครุภัณฑ์และคอลัมน์ข้อมูลโครงการจากไฟล์เดิม
const textTd = {
  project_name: 'ชื่อประเภทบัญชีครุภัณฑ์',
  project_start: 'ระยะเวลาดําเนินโครงการ (เริ่มต้น)',
  project_finish: 'ระยะเวลาดําเนินโครงการ (สิ้นสุด)',
  project_detail: 'รายละเอียดโครงการ',
  project_object: 'วัตถุประสงค์โครงการ',
  project_output_goal: 'เป้าหมายเชิงผลผลิต',
  project_outcome_goal: 'เป้าหมายเชิงผลลัพธ์',
  project_expected_benefit: 'ผลที่คาดว่าจะได้รับ',
  project_benefit: 'กลุ่มเป้าหมาย/ผู้ที่ได้รับประโยชน์',

  project_equipment_category_name: 'หมวด',
  project_equipment_account_type_name: 'ประเภทบัญชีครุภัณฑ์',

  project_type_name: 'ข้อมูลประเภทโครงการ',
  project_national_strategy_name: 'ข้อมูลยุทธศาสตร์ชาติ 20 ปี',
  project_master_plan_name: 'แผนแม่บทชาติ',
  project_development_plan_name: 'แผนพัฒนาเศรษฐกิจ',
  project_development_goal_name: 'เป้าหมายการพัฒนาที่ยั่งยืน (SDGs)',
  project_province_strategy_name: 'ข้อมูลยุทธศาสตร์จังหวัด',
  project_local_strategy_name: 'ข้อมูลยุทธศาสตร์องค์การปกครองท้องถิ่น (อปท.)',
  project_municipality_strategy_name: 'ข้อมูลยุทธศาสตร์เทศบาลนครนนทบุรี',
  project_non_livable_name: 'ข้อมูล 6 ดีของจังหวัดนนทบุรี',
  project_it_master_plan_name: 'ข้อมูลแผนปฎิบัติการดิจิทัลระยะ 5 ปี',
  project_smart_city_name: 'ข้อมูล Smart City',
  project_policy_name: 'ข้อมูลนโยบายนายกเทศมนตรีประจำปี',

  project_plan_name: 'ข้อมูลแผนงาน',

  // แสดงจาก project_revenue_budget[0].revenue_budget_type_name
  // revenue_budget_type_name: 'แหล่งที่มาของเงินงบประมาณ (งบประมาณรายรับ)',
  project_revenue_budget_type_name: 'แหล่งที่มาของเงินงบประมาณ (งบประมาณรายรับ)',
  project_expenditure_budget_type_name: 'เงินงบประมาณ (งบประมาณรายจ่าย)',
  project_total_budget: 'ยอดงบประมาณบัญชีครุภัณฑ์',

  project_department_name: 'หน่วยงานเจ้าของบัญชีครุภัณฑ์',
  project_responsible: 'ผู้รับผิดชอบโครงการ',
  project_note: 'หมายเหตุ/บันทึก',

  project_create_user_data: 'ข้อมูลผลการดำเนินงานของเจ้าของครุภัณฑ์',
  project_status: 'สถานะของโครงการ',
};

export default class ImportProject extends React.Component {
  state = {
    excelData: null,
    ArrayData: [],
    logError: '',
    apiErrors: [],
    loading: false,
  };

  thaiMonths = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'];

  resetFileInput = () => {
    const el = document.getElementById('file');
    if (el) el.value = '';
  };

  resetState = () => {
    this.setState({ excelData: null, ArrayData: [], logError: '', apiErrors: [] });
  };

  toNumber = v => {
    if (v === null || v === undefined || v === '') return 0;
    if (typeof v === 'number') return v;
    if (typeof v === 'string') {
      const cleaned = v.replace(/[^\d.-]/g, '');
      const num = Number(cleaned);
      return Number.isFinite(num) ? num : 0;
    }
    return 0;
  };

  toInt = v => {
    const n = this.toNumber(v);
    return Number.isFinite(n) ? Math.trunc(n) : 0;
  };

  formatMoney = v => {
    const n = this.toNumber(v);
    return Number(n).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // แปลง "YYYY-MM-DD 12:00:00" -> "วัน เดือน พ.ศ. 2568"
  formatThaiDateBE = val => {
    if (!val) return '';
    const ymd = String(val).split(' ')[0];
    const [y, m, d] = ymd.split('-').map(n => parseInt(n, 10));
    if (!y || !m || !d) return '';
    // ป้องกันการบวก 543 ซ้ำ หากได้รับปี พ.ศ. มาแล้ว
    const beYear = y > 2400 ? y : y + 543;
    return `${d} ${this.thaiMonths[m - 1]} พ.ศ. ${beYear}`;
  };

  toGregorianYear = year => {
    const numericYear = Number(year);
    if (!Number.isFinite(numericYear)) return null;
    return numericYear > 2400 ? numericYear - 543 : numericYear;
  };

  normalizeHeader = value => String(value ?? '').normalize('NFKC').replace(/\s+/g, '');

  getImportField = header => {
    const normalized = this.normalizeHeader(header);
    if (normalized === 'revenue_budget_type_name') return 'project_revenue_budget_type_name';
    if (normalized === 'create_user_data') return 'project_create_user_data';
    return Object.keys(textTd).find(key => key === normalized || this.normalizeHeader(textTd[key]) === normalized) || String(header ?? '').trim();
  };

  // รองรับ: Excel serial number, dd/mm/yyyy, yyyy-mm-dd, Date object
  chengDate = e => {
    if (e === undefined || e === null || e === '') return '';

    // Date object
    if (e instanceof Date && !isNaN(e)) {
      const d = String(e.getDate()).padStart(2, '0');
      const m = String(e.getMonth() + 1).padStart(2, '0');
      // Excel อาจแปลงวันที่ที่กรอกเป็น พ.ศ. เช่น 6/1/2569
      // ให้เป็น Date ที่มีปี 2569 จึงต้องแปลงกลับเป็น ค.ศ. ก่อนส่ง API
      const y = this.toGregorianYear(e.getFullYear());
      return `${y}-${m}-${d} 12:00:00`;
    }

    let finalDate = '';

    // Excel serial number
    if (typeof e === 'number') {
      const excelDate = XLSX.SSF.parse_date_code(e);
      if (!excelDate) return '';
      finalDate = `${excelDate.d}/${excelDate.m}/${excelDate.y}`;
    } else if (typeof e === 'string') {
      const s = e.trim();
      if (!s) return '';

      // dd/mm/yyyy (รวมทั้ง พ.ศ.)
      if (s.includes('/')) {
        finalDate = s;
      }
      // yyyy-mm-dd หรือ dd-mm-yyyy
      else if (s.includes('-')) {
        const part = s.split(' ')[0];
        const pieces = part.split('-').map(x => x.trim());
        if (pieces.length === 3) {
          const [a, b, c] = pieces;
          // ถ้าตัวแรกเป็นปี (4 หลัก) -> yyyy-mm-dd
          if (a.length === 4) finalDate = `${parseInt(c, 10)}/${parseInt(b, 10)}/${parseInt(a, 10)}`;
          // ไม่งั้นเดาว่า dd-mm-yyyy
          else finalDate = `${parseInt(a, 10)}/${parseInt(b, 10)}/${parseInt(c, 10)}`;
        }
      }
    }

    if (!finalDate) return '';

    const [d, m, y] = finalDate.split('/').map(x => String(x).trim());
    if (!d || !m || !y) return '';

    const gYear = this.toGregorianYear(y);
    if (!gYear) return '';

    const day = Number(d);
    const month = Number(m);
    const date = new Date(gYear, month - 1, day);
    if (!Number.isInteger(day) || !Number.isInteger(month) || !Number.isInteger(gYear) ||
        date.getFullYear() !== gYear || date.getMonth() !== month - 1 || date.getDate() !== day) return '';

    return `${gYear}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')} 12:00:00`;
  };
  normalizeNewlines = v => {
    if (v === null || v === undefined) return '';
    // แปลง \r\n และ \r ให้เป็น \n เพื่อให้ render ได้แน่นอน
    return String(v).replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  };
  handleInputChangeFile = e => {
    e.preventDefault();

    const fileTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;

    if (!fileTypes.includes(selectedFile.type)) {
      Swal.fire({
        title: 'ไฟล์ไม่ถูกต้อง',
        text: 'อนุญาตเฉพาะไฟล์ xlsx และ xls เท่านั้น',
        icon: 'error',
        timer: 2500,
      });
      this.resetFileInput();
      return;
    }

    const reader = new FileReader();
    reader.readAsArrayBuffer(selectedFile);

    reader.onload = ev => {
      try {
        const data = ev.target.result;

        // เก็บวันที่ Excel เป็น serial เพื่อถอดวัน/เดือน/ปีโดยไม่ให้ timezone ทำวันที่คลาด
        const workbook = XLSX.read(data, { type: 'buffer' });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];

        // อ่านแบบ AOA เพื่อเช็คว่ามีแถวคำอธิบาย (Row 2) ไหม
        const aoa = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' });
        const headerRow = (aoa[0] || []).map(this.getImportField);

        // ถ้าแถว 2 มีค่าเป็นข้อความไทยตาม textTd ให้ถือว่าเป็นแถวคำอธิบายและข้าม
        const row2 = aoa[1] || [];
        const hasThaiDescRow = ['project_name', 'project_start', 'project_finish'].every(key =>
          this.getImportField(row2[headerRow.indexOf(key)]) === key);

        // startRow: 1 = เริ่มข้อมูลจากแถว 2, 2 = เริ่มข้อมูลจากแถว 3
        const startRow = hasThaiDescRow ? 2 : 1;

        // อ่านเป็น object โดยใช้ header จากแถวแรก (key)
        const json = XLSX.utils.sheet_to_json(worksheet, {
          header: headerRow,
          range: startRow,
          defval: '',
          blankrows: false,
        });

        // ตรวจ: header ต้องมี key ที่เราใช้จริงอย่างน้อยบางตัว
        const mustHaveKeys = ['project_name', 'project_start', 'project_finish', 'project_department_name'];
        const headerOk = mustHaveKeys.every(k => headerRow.includes(k));
        if (!headerOk) {
          Swal.fire({
            title: 'Template ไม่ถูกต้อง',
            text: 'กรุณาใช้ไฟล์ template ที่ระบบกำหนด (แถวหัวตารางต้องเป็นชื่อคอลัมน์แบบ key เช่น project_start)',
            icon: 'error',
          });
          this.resetState();
          this.resetFileInput();
          return;
        }

        const batch = [];
        const errors = [];

        json.forEach(row => {
          // คำนวณเลขแถว Excel จริง (1-based)
          const excelRowNumber = row.__rowNum__ + 1;

          const projectStart = this.chengDate(row.project_start);
          const projectFinish = this.chengDate(row.project_finish);

          if(!row.project_name){
            errors.push(`แถว ${excelRowNumber}: กรุณากรอกชื่อประเภทบัญชีครุภัณฑ์`);
            return;
          }
          // วันที่เริ่ม/สิ้นสุด ต้องมี
          if (!projectStart || !projectFinish) {
            errors.push(`แถว ${excelRowNumber}: กรุณากรอกวันที่เริ่มต้นและวันที่สิ้นสุด`);
            return;
          }

          if (projectStart > projectFinish) {
            errors.push(`แถว ${excelRowNumber}: วันที่เริ่มต้นต้องไม่อยู่หลังวันที่สิ้นสุด`);
            return;
          }

          // หน่วยงานต้องมี
          if (!row.project_department_name) {
            errors.push(`แถว ${excelRowNumber}: กรุณากรอกหน่วยงานเจ้าของบัญชีครุภัณฑ์`);
            return;
          }

          if (!String(row.project_equipment_category_name || '').trim() ||
              !String(row.project_equipment_account_type_name || '').trim()) {
            errors.push(`แถว ${excelRowNumber}: กรุณากรอกหมวดและประเภทบัญชีครุภัณฑ์`);
            return;
          }

          const totalBudget = this.toNumber(row.project_total_budget);
          const revenueTypeName = row.revenue_budget_type_name || row.project_revenue_budget_type_name || '';

          const projectRevenueBudget = revenueTypeName && totalBudget > 0
            ? [{ revenue_budget_type: '', revenue_budget_type_name: revenueTypeName, revenue_budget_total: totalBudget }]
            : [];

          batch.push({
            project_name: row.project_name || '',
            project_start: projectStart,
            project_finish: projectFinish,
            project_detail: row.project_detail || '',
            project_object: row.project_object || '',
            project_output_goal: row.project_output_goal || '',
            project_outcome_goal: row.project_outcome_goal || '',
            project_expected_benefit: row.project_expected_benefit || '',
            project_benefit: row.project_benefit || '',

            project_equipment_category_name: row.project_equipment_category_name || '',
            project_equipment_account_type_name: row.project_equipment_account_type_name || '',

            project_type_name: row.project_type_name || '',
            project_national_strategy_name: row.project_national_strategy_name || '',
            project_master_plan_name: row.project_master_plan_name || '',
            project_development_plan_name: row.project_development_plan_name || '',
            project_development_goal_name: row.project_development_goal_name || '',
            project_province_strategy_name: row.project_province_strategy_name || '',
            project_local_strategy_name: row.project_local_strategy_name || '',
            project_municipality_strategy_name: row.project_municipality_strategy_name || '',
            project_non_livable_name: row.project_non_livable_name || '',
            project_it_master_plan_name: row.project_it_master_plan_name || '',
            project_smart_city_name: row.project_smart_city_name || '',
            project_policy_name: row.project_policy_name || '',

            project_plan_name: row.project_plan_name || '',

            // ตัวจริงที่จะส่งไป backend
            project_revenue_budget: projectRevenueBudget,
            project_revenue_budget_type_name: revenueTypeName,
            project_expenditure_budget_type_name: row.project_expenditure_budget_type_name || '',
            project_total_budget: totalBudget,

            project_department_name: row.project_department_name || '',
            project_responsible: row.project_responsible || '',
            project_note: row.project_note || '',

            project_create_user_data: row.project_create_user_data || row.create_user_data || '',
            project_status: row.project_status ?? '',
          });
        });

        // ถ้ามี error: แจ้งครั้งเดียว แล้วไม่รับไฟล์นี้
        if (errors.length) {
          const maxShow = 12;
          const html =
            `<div style="text-align:left">` +
            errors
              .slice(0, maxShow)
              .map(e => `• ${e}`)
              .join('<br/>') +
            (errors.length > maxShow ? `<br/>… และอีก ${errors.length - maxShow} รายการ` : '') +
            `</div>`;

          Swal.fire({
            title: 'ข้อมูลไม่ครบถ้วน',
            html,
            icon: 'warning',
          });

          this.resetState();
          this.resetFileInput();
          return;
        }

        // ถ้าไม่มีข้อมูล valid เลย
        if (!batch.length) {
          Swal.fire({
            title: 'ไม่มีข้อมูล',
            text: 'ไม่พบแถวข้อมูลที่ถูกต้องในไฟล์',
            icon: 'warning',
          });
          this.resetState();
          this.resetFileInput();
          return;
        }

        this.setState({ excelData: json, ArrayData: [batch], logError: '', apiErrors: [] });
      } catch (err) {
        Swal.fire({
          title: 'Error reading file',
          text: 'Could not parse the file. Please check the file format.',
          icon: 'error',
        });
        this.resetState();
        this.resetFileInput();
      }
    };

    reader.onerror = () => {
      Swal.fire({
        title: 'Error reading file',
        text: 'Could not read the file. Please check the file format.',
        icon: 'error',
        timer: 2500,
      });
      this.resetState();
      this.resetFileInput();
    };
  };

  showImportError = data => {
    const message = typeof data.message === 'string' ? data.message : 'ไม่สามารถนำเข้าข้อมูลได้ กรุณาลองใหม่';
    const apiErrors = (Array.isArray(data.data_errors) ? data.data_errors : []).map(item => {
      const matchingRows = (this.state.excelData || []).filter(row =>
        row.project_name === item.project_name && Number.isInteger(row.__rowNum__));
      const details = Array.isArray(item.error) ? item.error : [item.error || 'กรุณาตรวจสอบข้อมูล'];
      return {
        name: item.project_name || 'ไม่ระบุชื่อบัญชีครุภัณฑ์',
        rows: matchingRows.map(row => row.__rowNum__ + 1),
        details: details.map(detail => typeof detail === 'string' ? detail : JSON.stringify(detail)),
      };
    });
    this.setState({ logError: message, apiErrors, loading: false });
    Swal.fire({
      title: 'นำเข้าข้อมูลไม่สำเร็จ',
      text: apiErrors.length
        ? `พบข้อมูลที่ต้องตรวจสอบ ${apiErrors.length} รายการ ดูชื่อบัญชีครุภัณฑ์และรายละเอียดในตารางด้านล่าง`
        : message,
      icon: 'warning',
      confirmButtonText: 'ดูรายละเอียด',
    });
  };

  handleSubmit = () => {
    const { ArrayData } = this.state;

    // ต้องเช็ค flat().length ไม่ใช่ length ของ ArrayData
    if (this.state.loading || !ArrayData.flat().length) return;

    this.setState({ loading: true, logError: '', apiErrors: [] });

    const promises = ArrayData.map(batch =>
      axios.post(process.env.REACT_APP_SOURCE_URL + '/projectEquipments/importExcel', batch, {
        headers: { Authorization: `Bearer ${token_id}` },
      }),
    );

    return Promise.all(promises)
      .then(responses => {
        const failed = responses.find(response => response.data &&
          (response.data.success === false || (Array.isArray(response.data.data_errors) && response.data.data_errors.length)));
        if (failed) {
          this.showImportError(failed.data);
          return;
        }
        this.setState({ excelData: null, ArrayData: [], logError: '', apiErrors: [], loading: false });
        this.resetFileInput();
        Swal.fire({
          title: 'บันทึกข้อมูลสำเร็จ',
          icon: 'success',
          timer: 1000,
        });
      })
      .catch(err => {
        this.showImportError((err.response && err.response.data) || {
          message: 'ไม่สามารถเชื่อมต่อระบบได้ กรุณาลองใหม่',
        });
      });
  };

  render() {
    const { logError, apiErrors, excelData, ArrayData, loading } = this.state;
    const headers = Object.keys(textTd);

    return (
      <>
        <Row>
          <Col sm={12}>
            <span>
              Download template:{' '}
              <a href="/templateasset.xlsx" download>
                template.xlsx
              </a>
            </span>
          </Col>

          <Label for="file" sm={12}>
            แนบไฟล์:
          </Label>

          <Col sm={12}>
            <input
              name="file"
              id="file"
              type="file"
              className="form-control"
              style={{
                width: '100%',
                height: 'fit-content',
                padding: '0',
              }}
              // สำคัญ: ทำให้เลือกไฟล์เดิมซ้ำได้ (onChange จะยิงทุกครั้ง)
              onClick={e => {
                e.target.value = null;
              }}
              onChange={this.handleInputChangeFile}
            />
            <FormText>คาดหวังประเภทไฟล์ 'xlsx'</FormText>
          </Col>
        </Row>

        {logError && (
          <div className="alert alert-danger" role="alert" style={{ whiteSpace: 'pre-line' }}>
            {logError}
          </div>
        )}

        {apiErrors.length > 0 && (
          <div className="mb-3" role="region" aria-label="รายละเอียดข้อผิดพลาดจากการนำเข้าครุภัณฑ์">
            <p><strong>พบข้อมูลที่ต้องตรวจสอบ {apiErrors.length} รายการ</strong> กรุณาแก้ข้อมูลใน Excel ให้ตรงกับข้อมูลอ้างอิงในระบบ แล้วเลือกไฟล์ใหม่</p>
            <div className="table-responsive" style={{ maxHeight: 480, overflowY: 'auto' }}>
              <table className="table table-bordered table-striped">
                <thead><tr><th>แถว Excel</th><th>ชื่อบัญชีครุภัณฑ์</th><th>ข้อมูลที่ต้องตรวจสอบ</th></tr></thead>
                <tbody>{apiErrors.map((error, index) => (
                  <tr key={index}>
                    <td>{error.rows.length ? error.rows.join(', ') : '—'}</td>
                    <td style={{ minWidth: 220, whiteSpace: 'pre-wrap' }}>{error.name}</td>
                    <td style={{ minWidth: 320 }}><ul className="mb-0 pl-3">{error.details.map((detail, i) => (
                      <li key={i} style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{detail}</li>
                    ))}</ul></td>
                  </tr>
                ))}</tbody>
              </table>
            </div>
          </div>
        )}

        <Row className="justify-content-center">
          <Col sm={1}>
            <Button
              onClick={this.handleSubmit}
              // สำคัญ: ต้องดูจำนวนแถวจริง (flat)
              disabled={!ArrayData.flat().length || loading}
              color="primary"
            >
              {loading ? <Spinner size="sm" /> : 'Upload'}
            </Button>
          </Col>
          <Col sm={1}>
            <Button
              onClick={() => {
                this.resetState();
                this.resetFileInput();
              }}
              color="danger"
            >
              Clear
            </Button>
          </Col>
        </Row>

        <div className="col-md-12 viewer">
          {excelData ? (
            <table className="table table-responsive">
              <thead>
                <tr style={{ backgroundColor: '#e0ecfa' }}>
                  {headers.map(key => (
                    <th key={key}>{textTd[key]}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {ArrayData.flat().length ? (
                  ArrayData.flat().map((row, index) => (
                    <tr key={index}>
                      {headers.map(key => (
                        <td key={key}>
                          {key === 'project_total_budget' ? (
                            this.formatMoney(row[key])
                          ) : key === 'project_start' || key === 'project_finish' ? (
                            this.formatThaiDateBE(row[key])
                          ) : key === 'revenue_budget_type_name' ? (
                            row.project_revenue_budget && row.project_revenue_budget[0] && row.project_revenue_budget[0].revenue_budget_type_name ? (
                              row.project_revenue_budget[0].revenue_budget_type_name
                            ) : (
                              ''
                            )
                          ) : key === 'project_detail' ? (
                            <div style={{ whiteSpace: 'pre-wrap' }}>{row[key]}</div>
                          ) : (
                            row[key]
                          )}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={headers.length} className="text-center">
                      ไม่มีข้อมูล
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          ) : (
            <p>กรุณาเลือกไฟล์</p>
          )}
        </div>
      </>
    );
  }
}
